// import i18n from '@/i18n'
// import { _plus, _minus, _times, _percentage } from '@/helpers/bigNumber'

export const fileNumber = state => (key) => {
  return state._[key].fileNumber
}

export const appraisalAmount = state => (key) => {
  return state._[key].appraisalAmount
}

export const invoiceAmount = state => (key) => {
  return state._[key].invoiceAmount
}

export const getList = state => {
  return state.list
}

export const getArray = state => {
  return state.list.map(k => {
    return state._[k]
  })
}

export const apificate = (state, getters) => {
  if (state.list.length < 1) return undefined
  return state.list.map(k => {
    let inmobilizedData = Object.assign({}, state._[k])
    return inmobilizedData
  })
}
